import { createContext } from 'react';

export const InsuranceContainerContext = createContext({
  offerId: ''
});
